export default "<div class=\"login-container\">\n      <div *ngIf=\"errorMessage\" class=\"error\">{{ errorMessage }}</div>\n  </div>\n  "